module.exports = __webpack_public_path__ + "static/media/ornaments-sm.b571443f.gif";